(function() {
	'use strict';	
	var serializeUrl = avm.require('avast.url.serialize'),
		unserializeUrl = avm.require('avast.url.unserialize'),
		createLink = function(currentLink) {
			var newLink = currentLink.substring(0, currentLink.indexOf('?')),
				linkParams = unserializeUrl();
				newLink += currentLink + '?' + serializeUrl(linkParams);

			return newLink;
		},
		path = window.location.href,
		URLparams = unserializeUrl(path);		
		
				var $targetLinks = $('.buy-link');
			
				$targetLinks.each(function(index) {
					var $self = $(this),
						selfLink = $self.attr('href');						
					$self.attr('href', createLink(selfLink));
				});
})();
